
export class baseCommand {

    public MAXIMUM_SIZE_DATA_TO_SEND = 32767;

    protected object() {
        return {};
    }

    public jsonString(): string {
        return JSON.stringify(this.object());
    }
}
